// extracted by mini-css-extract-plugin
module.exports = {"list_title":"list_title-36HUNFX9"};